module.exports = __webpack_public_path__ + "img/smile-bleu.1cc2137e.svg";